import { render, staticRenderFns } from "./RiskInfo.vue?vue&type=template&id=b5ca58ea&"
import script from "./RiskInfo.vue?vue&type=script&lang=js&"
export * from "./RiskInfo.vue?vue&type=script&lang=js&"
import style0 from "./RiskInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RiskInfo.vue"
export default component.exports